import { Box, IconButton, styled } from '@mui/material';
import { shadows } from 'common/theme/shadows';

import type { EventContentArg } from '@fullcalendar/core';

export const StyledEventContent = styled(Box, {
  name: 'CalendarItem',
  shouldForwardProp: (prop) => prop === 'children',
})<EventContentArg>(({ theme: { palette }, isPast }) => ({
  '.fc-v-event:has(&)': {
    ...(isPast && {
      backgroundColor: palette.grey[300],
      borderColor: palette.grey[300],
    }),

    '& .MuiButtonBase-root': {
      display: 'none',
    },

    '&:hover': {
      boxShadow: shadows['light-shadow-8'],
      // The accent: `blue[600]` in the legacy theme, `Color/Blue/Primary` under the refresh.
      ...(!isPast && {
        '--fc-event-bg-color': palette.primary.main,
        '--fc-event-border-color': palette.primary.main,
      }),

      '& .MuiButtonBase-root': {
        display: 'flex',
      },
    },
  },
}));

export const RemoveButton = styled(IconButton)({
  position: 'absolute',
  top: 5,
  right: 4,
  color: 'inherit',
});

RemoveButton.defaultProps = {
  size: 'xs',
};
